module.exports = __webpack_public_path__ + "img/second_img_dark.7d104e45.png";